import React, { useEffect, useMemo, useState } from 'react';
import { MuiThemeProvider } from '@material-ui/core';
import { conventionPageTheme } from './conventionPageTheme';
import { cssVariables } from './tokens';
import './conventionPage.css';

const DARK_QUERY = '(prefers-color-scheme: dark)';

const matchDark = () =>
    typeof window !== 'undefined' && typeof window.matchMedia === 'function' ? window.matchMedia(DARK_QUERY) : null;

// Follows the system colour scheme (front-hia has no theme toggle); updates when the system setting changes.
export const usePrefersDark = () => {
    const [dark, setDark] = useState(() => {
        const query = matchDark();
        return !!(query && query.matches);
    });
    useEffect(() => {
        const query = matchDark();
        if (!query) return undefined;
        const onChange = (event) => setDark(event.matches);
        if (query.addEventListener) query.addEventListener('change', onChange);
        else if (query.addListener) query.addListener(onChange);
        return () => {
            if (query.removeEventListener) query.removeEventListener('change', onChange);
            else if (query.removeListener) query.removeListener(onChange);
        };
    }, []);
    return dark;
};

// Wraps ONLY the convention page: its MUI theme, its `.hia-ack` root and the CSS variables built from tokens.js.
const ConventionThemeScope = ({ children }) => {
    const scheme = usePrefersDark() ? 'dark' : 'light';
    const theme = useMemo(() => conventionPageTheme(scheme), [scheme]);
    const style = useMemo(() => cssVariables(scheme), [scheme]);
    return (
        <MuiThemeProvider theme={theme}>
            <div className="hia-ack" data-scheme={scheme} style={style}>
                {children}
            </div>
        </MuiThemeProvider>
    );
};

export default ConventionThemeScope;
